import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { WorldPageHeader } from '../../components/world/WorldPageHeader';
import { CopyLinkButton } from '../../components/guide/CopyLinkButton';
import { ValidationLegend } from '../../components/progression/ValidationBadge';
import { ItemLevelExplainer } from '../../components/progression/ItemLevelExplainer';
import { NpcCard } from '../../components/progression/NpcCard';
import { recipeMenu, getRecipe, recipePath } from '../../data/guide/recipes';
import { useWorldLookup } from '../../hooks/useWorldLookup';
export function WingsGuide() {
  const {
    lookup
  } = useWorldLookup();
  useEffect(() => {
    document.title = 'Alas y capas · Guía MU Vanguard';
  }, []);
  return <div className="space-y-8 md:space-y-10" data-id="element-2316" data-mp="2ekbqbs77xkks">
      <WorldPageHeader crumbs={[{
      label: 'Guía',
      to: '/guia'
    }, {
      label: 'Alas y capas'
    }]} eyebrow="Guía interactiva · Chaos Machine" title="Alas y capas" data-id="element-2317" data-mp="2elmuht4ksucf">
        <p className="mt-2 max-w-2xl text-sm text-gray-300 md:text-base" data-id="element-2318" data-mp="2moqttnp07uck">Elige qué quieres crear. Cada receta muestra sus ingredientes por separado, con “Dónde conseguirlo” en cada material.</p>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-sm text-gray-300" data-id="element-2319" data-mp="2vpgi86bxqig9">
          <CopyLinkButton data-id="element-2320" data-mp="2vn2ruas79uf1" />
        </div>
      </WorldPageHeader>

      <NpcCard npcId="chaos-goblin" lookup={lookup} data-id="element-2321" data-mp="2qrnbnc6pzmfg" />

      <nav aria-label="Recetas" data-id="element-2322" data-mp="230hyx5w2ta9d">
        <ol className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-2323" data-mp="231kptdtefcpa">
          {recipeMenu.map((id, i) => {
          const r = getRecipe(id)!;
          return <li key={id} data-id="element-2324" data-mp="2cqb2bjm2ej2j" data-mpi={i}>
                <Link to={recipePath(id)} className="group flex h-full items-center gap-3 rounded-2xl border border-white/10 bg-[#0A1628] p-3.5 transition-colors duration-150 hover:border-[#D4AF37]/50 md:p-4" data-id="element-2325" data-mp="2crmb5xudah0i">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#D4AF37]/10 font-cinzel text-sm font-bold text-[#D4AF37]" data-id="element-2326" data-mp="1k8p6bckx5r26">{i + 1}</span>
                  <span className="min-w-0 flex-1" data-id="element-2327" data-mp="3fe810f3vj20r">
                    <span className="block font-cinzel font-bold text-white" data-id="element-2328" data-mp="3fbc14l8gu39o">{r.title}</span>
                    <span className="mt-0.5 block text-xs text-gray-400 md:text-sm" data-id="element-2329" data-mp="3kagd1jmryf3p">{r.summary}</span>
                  </span>
                  <ArrowRight className="h-4 w-4 shrink-0 text-gray-500 group-hover:text-[#D4AF37]" aria-hidden="true" data-id="element-2330" data-mp="3u2ck3k6u9fk2" />
                </Link>
              </li>;
        })}
        </ol>
        <p className="mt-2 text-xs text-gray-500" data-id="element-2331" data-mp="31dnkxqpcfkay">Orden sugerido: Arma Chaos → Evo 1 → Evo 2 → Condor Feather → Evo 3. Las capas parten de unas alas Evo 1.</p>
      </nav>

      <ItemLevelExplainer data-id="element-2332" data-mp="36bgqchitoaa6" />
      <ValidationLegend data-id="element-2333" data-mp="3aed8k74ga4dl" />
    </div>;
}